<template>
  <Catalogs
    title="Подразделения"
    create-text="Новое"
    :fetch-data="fetchData"
    :route-create="'DepartmentAdd'"
    :route-edit="'DepartmentEdit'"
    :route-view="'DepartmentView'"
    :route-path="'/departments'"
    :can-edit="canEditDepartmentCatalogs()"
  />
</template>

<script>
import catalogs from "../../../network/catalogs";
  import permissions, {PERM} from "../../../utilites/permissions";
    import Catalogs from "../Catalogs.vue";

export default {
  name: "Departments",
  components: { Catalogs },
  mixins: [
    catalogs,
    permissions
  ],
  methods: {
    async fetchData(data) {
      return await this.getDepartments(data);
    },
    canEditDepartmentCatalogs() {
      return this.hasPermission([PERM.CATALOG_DEPARTMENT_EDIT]);
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Catalogs/Departments/Departments.vue